var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var CodeSvg = /* @__PURE__ */ __name(function CodeSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M16 2.222c-7.609 0-13.778 6.169-13.778 13.778s6.169 13.778 13.778 13.778c7.609 0 13.778-6.169 13.778-13.778v0 0c0-7.609-6.169-13.778-13.778-13.778v0zM10.667 18.249c0.293 0.289 0.591 0.578 0.889 0.889 0.15 0.143 0.243 0.344 0.243 0.567 0 0.21-0.082 0.4-0.217 0.54l0-0c-0.137 0.143-0.33 0.232-0.543 0.232-0.224 0-0.425-0.098-0.563-0.254l-0.001-0.001q-1.849-1.827-3.684-3.671c-0.148-0.135-0.24-0.329-0.24-0.544 0-0.193 0.074-0.369 0.196-0.501l-0 0.001 0.044-0.044q1.836-1.844 3.684-3.671c0.138-0.158 0.34-0.257 0.566-0.257 0.212 0 0.404 0.088 0.541 0.23l0 0c0.139 0.141 0.225 0.335 0.225 0.549 0 0.227-0.097 0.432-0.252 0.575l-0.001 0c-0.951 0.964-1.916 1.92-2.871 2.876-0.062 0.062-0.124 0.138-0.227 0.244zM18.8 10.907q-0.564 1.551-1.129 3.111-1.338 3.76-2.711 7.484c-0.068 0.374-0.389 0.655-0.777 0.658h-0c-0.001 0-0.003 0-0.004 0-0.427 0-0.773-0.346-0.773-0.773 0-0.128 0.031-0.249 0.086-0.355l-0.002 0.004q0.782-2.138 1.556-4.267l2.289-6.267c0.069-0.299 0.288-0.534 0.572-0.625l0.006-0.002c0.066-0.021 0.142-0.034 0.221-0.034 0.212 0 0.404 0.090 0.539 0.233l0 0c0.137 0.137 0.221 0.325 0.221 0.534 0 0.107-0.022 0.21-0.063 0.302l0.002-0.005zM25.151 16.596l-3.556 3.556c-0.154 0.195-0.39 0.319-0.654 0.319-0.050 0-0.099-0.004-0.146-0.013l0.005 0.001c-0.358-0.072-0.625-0.384-0.625-0.759 0-0.228 0.098-0.432 0.255-0.574l0.001-0.001c0.6-0.622 1.213-1.222 1.827-1.831l1.333-1.298-2.822-2.813c-0.111-0.093-0.222-0.196-0.324-0.293-0.143-0.142-0.232-0.338-0.232-0.556s0.089-0.414 0.232-0.556l0-0c0.139-0.14 0.331-0.226 0.543-0.226 0.223 0 0.424 0.095 0.563 0.248l0 0.001c0.787 0.773 1.564 1.556 2.342 2.333l1.298 1.284c0.167 0.143 0.272 0.355 0.272 0.591s-0.105 0.448-0.271 0.59l-0.001 0.001z"
  }));
}, "CodeSvg");
var CodeIcon = /* @__PURE__ */ __name(function CodeIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: CodeSvg
  }, props));
}, "CodeIcon");
export {
  CodeIcon
};
